// extracted by mini-css-extract-plugin
module.exports = {"new-offer-price-container":"Offer_new-offer-price-container__PRv5T","hover-card":"Offer_hover-card__sl_0N"};